export default "__VITE_ASSET__BoPcsmJn__"